export interface StatisticState {
  emailStatisticDetail: EmailDetailItem[];
  emailStatisticDetailFlag: string|null;

  emailStatisticGroup: EmailGroupItem[];
  emailStatisticGroupEvents: EmailGroupEventsType | {};
  emailMessageCount: number;
  emailGroupings: {
    emailGroup: string[];
    emailGroupByOptionally: string[];
    emailGroupEventsByOptionally: string[];
    emailGroupIncoming: string[];
  };
  emailDetailEvents: EmailDetailEventsItem[];
  emailDetailEventsInfo: EmailDetailEventsInfo | {};
}

// - - -

export interface EmailDetailItem {
  id: string;
  create_date: string;
  originator: string;
  recipient: string;
  partner: string;
  service_provider: string;
  subject: string;
  status: string;
  error_code?: number;
}

export class EmailDetailItemInfo {
  id: string = '';
  create_date: string|null = null;
  sent_date?: string = undefined;
  delivery_date?: string = undefined;
  read_date?: string = undefined;
  defer_date?: string = undefined;
  external_id?: string = undefined;
  service_provider?: string = undefined;
  originator: string|null = null;
  recipient: string|null = null;
  parent_message_id?: string = undefined;
  parent_message_channel?: string = undefined;
  bulk_id?: string = undefined;
  partner: string|null = null;
  partner_user_login?: string = undefined;
  status: string|null = null;
  error_code?: number = undefined;
  error_description?: string = undefined;
  message_type?: string = undefined;
  subject?: string = undefined;
  priority?: number = undefined;
  partner_price?: string = undefined;
  provider_price?: string = undefined;
  broker_account_login?: string = undefined;
  template_id?: string = undefined;
  connection_type?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  special_unsubscribe_rule?: string = undefined;
  unsubscribe_links_regex?: string = undefined;
  unsubscribe_rule?: string = undefined;
  subscribe_links_regex?: string = undefined;
  subscribe_rule?: string = undefined;
  proxy_links_regex?: string = undefined;
  events_count?: number = undefined;
  custom_data?: object = undefined;
}

export class EmailDetailFilterParams {
  date_from: string;
  date_to: string;
  originator?: string = undefined;
  recipient?: string = undefined;
  partner?: string = undefined;
  service_provider?: string = undefined;
  status?: string = undefined;
  error_code?: number = undefined;
  message_type?: string = undefined;
  sent_date_from?: string = undefined;
  sent_date_to?: string = undefined;
  deliver_date_from?: string = undefined;
  deliver_date_to?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  broker_account_login?: string = undefined;
  partner_user_login?: string = undefined;
  id?: string = undefined;
  external_id?: string = undefined;
  ext_id1?: string = undefined;
  ext_id2?: string = undefined;
  ext_id3?: string = undefined;
  ext_id4?: string = undefined;
  ext_id5?: string = undefined;
  page_number: number = 1;
  message_direction: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.message_direction = "mt";
  }
}

// - - -

export interface EmailGroupItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  template_id?: number;
  bulk_id?: string;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  failed: number;
  rejected: number;
  deferred: number;
  total: number;
  partner_price: string;
  provider_price: string;
}

export class EmailGroupFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  originator?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: string = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}

export interface EmailGroupEventsType {
  events_summary: {
    date?: string;
    total: number,
    openings: number,
    subscribings: number,
    unsubscribings: number,
    links_followings: number
  },
  events: EmailGroupEventsItem[]
}

export interface EmailGroupEventsItem {
  date?: string;
  originator?: string;
  service_provider?: string;
  partner?: string;
  template_id?: number;
  bulk_id?: number;
  delivered: number;
  read: number;
  not_delivered: number;
  transmitted: number;
  failed: number;
  rejected: number;
  deferred: number;
  total: number;
  partner_price: string;
  provider_price: string;
  openings: number;
  subscribings: number;
  unsubscribings: number;
  links_followings: number;
  broker_account_login: string,
  message_type: string
}

export class EmailGroupEventsFilterParams {
  date_from: string;
  date_to: string;
  group_by: string;
  originator?: string = undefined;
  service_provider?: string = undefined;
  partner?: string = undefined;
  template_id?: number = undefined;
  bulk_id?: number = undefined;
  broker_account_login?: number = undefined;
  message_type?: number = undefined;
  message_direction: string;

  constructor(date_from: string, date_to: string, group_by: string) {
    this.date_from = date_from;
    this.date_to = date_to;
    this.group_by = group_by;
    this.message_direction = "mt";
  }
}

export interface EmailDetailEventsItem {
  id: number;
  date: string;
  type: string;
}

export class EmailDetailEventsFilterParams {
  date_from: string;
  date_to: string;
  type?: string;

  constructor(date_from: string, date_to: string) {
    this.date_from = date_from;
    this.date_to = date_to;
  }
}

export interface EmailDetailEventsInfo {
  id?: number;
  date: string | null;
  type: string | null;
  data?: object;
}
